export const generateUniqueKey = (): string => Math.random().toString(36).substring(7);
